import { render, staticRenderFns } from "./OnboardingSecondQuestion.vue?vue&type=template&id=23d4e6af"
import script from "./OnboardingSecondQuestion.vue?vue&type=script&lang=js"
export * from "./OnboardingSecondQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports